<div class="title">
  <h2>Your Quickflows</h2>
  <nav class="navigation-links">
    @for (menuItem of displayedMenuItems; track menuItem; let i = $index) {
    <div class="navigation-link-outer">
      <a
        class="navigation-link"
        (click)="onAutomationRulesNavigationClick(menuItem.text)"
        [class.active]="menuItem.text === step">
        <p class="navigation-link__text">{{ menuItem.text }}</p>
      </a>
    </div>
    }
  </nav>
  <div class="header-buttons">
    <pdq-button
      icon="Plus"
      variant="primary"
      [disabled]="disableAddRule || isLoading"
      (onClick)="addWorkflow()"
      label="Add Quickflow">
    </pdq-button>
    <div class="close-btn" title="close" (click)="onClose()"></div>
  </div>
</div>
<pdq-divider></pdq-divider>
<div class="body">
  <div class="panel">
    <div class="info">
      <span><b>{{activeRulesCount}}</b> active</span>
    </div>
  </div>
  <ng-template #target></ng-template>
</div>
